<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { toRef } from 'vue'
import useTeacherGuide from '~/composables/useTeacherGuide'
import useSlugify from '~/composables/useSlugify'
import { useContentHelper } from '~/composables/useContentHelper'
import RichTextRenderer from '~/components/utils/RichTextRenderer.vue'
import AuDialog from '~/components/ui/AuDialog.vue'
import TeacherSubitems from '~/components/subject/TeacherSubitems.vue'

const props = defineProps<{
  isOpen: boolean
  contentId: number | string
}>()

const emit = defineEmits(['closeGuide'])
const { t } = useI18n()
const { getTitle, isPackage, isArticleContent } = useContentHelper()
const { slugify } = useSlugify()

const { teacherArticle, teacherContent } = useTeacherGuide({
  contentId: Number(props.contentId),
  withContent: true,
  enabled: toRef(() => props.isOpen),
})
</script>

<template>
  <AuDialog
    :title="t('article.teacherGuide')"
    :open="isOpen"
    size="xl"
    @update:open="val => !val && emit('closeGuide')"
  >
    <template #content>
      <article class="prose prose-au prose-img:rounded-xl mx-auto">
        <div class="au-teacher-article">
          <RichTextRenderer :text="teacherArticle?.intro ?? ''" />
          <RichTextRenderer :text="teacherArticle?.body ?? ''" />
        </div>
        <div
          v-for="content in teacherContent"
          :id="slugify(getTitle(content))"
          :key="content.contentId"
          class="au-teacher-article"
        >
          <h2 v-text="getTitle(content)" />
          <TeacherSubitems
            v-if="isPackage(content)"
            :header="content"
          />
          <RichTextRenderer
            v-if="isArticleContent(content) && content.body"
            :text="content.body"
          />
        </div>
      </article>
    </template>
  </AuDialog>
</template>
